export function iterateGridElements(rows, callback) {
    if('rows' in rows) { rows = rows.rows; }

    for (let targetName in rows) {
        if (!rows.hasOwnProperty(targetName)) { continue; }

        let row = rows[targetName];

        if(callback('row', row) === false) {
            return;
        }

        if(!row.name) {
            const { type, entities } = row.type === 'widget'
                ? {type: 'widget', entities: row.nodes}
                : row.type === "widget_group"
                    ? {type: "widget_group", entities: row.nodes}
                    : row.type === 'row'
                        ? {type: 'row', entities: row.cols}
                        : {type: 'col', entities: row.rows};

            for(let entityKey in entities) {
                const entity = entities[entityKey];
                if (!entities.hasOwnProperty(entityKey)) continue;
                if(callback(type, entity) === false) {
                    return;
                }

                iterateGridElements(
                    type === 'widget' ? [entity] : entities,
                    callback
                );
            }
        }
    }
}

export function iterateGridTargets(rows, callback) {
    return iterateGridElements(rows, (type, obj) => {
        if(type === 'row' && obj.name) {
            return callback(obj.name);
        }
    });
}

export function getGridTargets(rows) {
    let targets = [];

    iterateGridTargets(rows, (name) => {
        targets.push(name); 
    });
    
    return targets;
}

export function hasTarget(rows, targetName) {
    let found = false;
    
    iterateGridTargets(rows, (name) => {
        if(name === targetName) {
            found = true;
            
            return false;
        } 
    });
    
    return found;
}